import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { ReportModel } from '@smarttask-common/src/lib/models/Report/Core/ReportModel';

export enum ReportActionTypes {
    ADD_REPORT = '[Report] Create Report',
    ADD_REPORTS = '[Report] Add Reports',
    UPSERT_REPORT = '[Report] Upsert Report',
    UPSERT_REPORTS = '[Report] Upsert Reports',
    UPDATE_REPORT = '[Report] Update Report',
    UPDATE_REPORTS = '[Report] Update Reports',
    DELETE_REPORT = '[Report] Delete Report',
    DELETE_REPORTS = '[Report] Delete Reports',
    DELETE_ALL_REPORTS = '[Report] Delete All Reports',
    DELETE_ALL = '[Report] Delete All',

    UPDATE_SELECTED_ID = '[Report] Update SelectedId',
}

export class UpdateSelectedReportId implements Action {
    readonly type = ReportActionTypes.UPDATE_SELECTED_ID;
    constructor(public selected_report_id: string) {}
}

export class AddOne implements Action {
    readonly type = ReportActionTypes.ADD_REPORT;
    constructor(public report: ReportModel) {}
}

export class AddMany implements Action {
    readonly type = ReportActionTypes.ADD_REPORTS;
    constructor(public reports: Array<ReportModel>) {}
}

export class UpsertOne implements Action {
    readonly type = ReportActionTypes.UPSERT_REPORT;

    constructor(public report: ReportModel) {}
}

export class UpsertMany implements Action {
    readonly type = ReportActionTypes.UPSERT_REPORTS;
    constructor(public reports: Array<ReportModel>) {}
}

export class UpdateOne implements Action {
    readonly type = ReportActionTypes.UPDATE_REPORT;
    constructor(public report: Update<ReportModel>) {}
}

export class UpdateMany implements Action {
    readonly type = ReportActionTypes.UPDATE_REPORTS;
    constructor(public reports: Array<Update<ReportModel>>) {}
}

export class DeleteOne implements Action {
    readonly type = ReportActionTypes.DELETE_REPORT;
    constructor(public id: string) {}
}

export class DeleteMany implements Action {
    readonly type = ReportActionTypes.DELETE_REPORTS;
    constructor(public ids: Array<string>) {}
}

export class DeleteAll implements Action {
    readonly type = ReportActionTypes.DELETE_ALL_REPORTS;
    constructor(public ids: Array<string>) {}
}

export class DeleteState implements Action {
    readonly type = ReportActionTypes.DELETE_ALL;
    constructor() {}
}

export type ReportActions =
    | AddOne
    | AddMany
    | UpsertOne
    | UpsertMany
    | DeleteOne
    | DeleteMany
    | DeleteAll
    | DeleteState
    | UpdateOne
    | UpdateMany
    | UpdateSelectedReportId;
